import { useNavigation } from '@react-navigation/native';
import React, { useState } from 'react';
import {
  Image,
  Linking,
  Modal,
  Platform,
  ScrollView,
  StatusBar,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import { SafeAreaView, useSafeAreaInsets } from 'react-native-safe-area-context';
import Feather from 'react-native-vector-icons/Feather';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import { Colors } from '../../constants/Colors';
import { Images } from '../../constants/Images';
import { NavigationProps } from '../../navigation/Routes';
import { AppRoutes } from '../../navigation/Routes.types';
import CompanyModal from '../../pages/Bag/components/CompanyModal/CompanyModal';
import DropDownMenu from '../../pages/Home/components/DropDownMenu/DropDownMenu';
import AuthService from '../../services/AuthService/AuthService';
import { useAuthStore } from '../../store/AuthStore';
import { useModalStore } from '../../store/MenuModalStore';
import { useLimitStore } from '../../store/LimitStore';
import { useUserStore } from '../../store/UserStore';
import { useBagStore } from '../../store/BagStore';
import { useFilterStore } from '../../store/FilterStore';
import { styles } from './styles';
import useExtendedTermsStore from '../../store/ExtendedTermsStore';
import { getAnalytics, logEvent } from '@react-native-firebase/analytics';
import analytics from '@react-native-firebase/analytics';
import { useIsDesktop } from '../../hooks/useIsDesktop';

interface IModalFilter {
  visible: boolean;
  onRequestClose: () => void;
  onPress: () => void;
}

const MenuModal = ({ visible, onRequestClose, onPress }: IModalFilter) => {
  const isDesktop = useIsDesktop();
  const insets = useSafeAreaInsets();
  const { setToken, token, defUser } = useAuthStore();
  const { clearCart } = useBagStore();
  const { clearFilters } = useFilterStore();
  const { navigate } = useNavigation<NavigationProps>();
  const { user, setTemporaryPasswordLogin } = useUserStore();
  const { limit, balance, loadingLimit } = useLimitStore();
  const digitalEnabled = useLimitStore(state => state.digital);
  const { closeModal } = useModalStore();
  const { clearData: clearExtendedTerms } = useExtendedTermsStore();
  const [companyModal, setCompanyModal] = useState<boolean>(false);
  const analyticsInstance = getAnalytics();

  const handleCloseModal = () => {
    setCompanyModal(false);
  };

  const openModal = () => {
    setCompanyModal(true);
  };

  const handleLogOff = () => {
    AuthService.logoutPost().catch(error => console.error(error));

    setToken('');
    defUser(null);
    closeModal();
    clearCart();
    clearFilters();
    clearExtendedTerms();
    setTemporaryPasswordLogin(false);
  };

  if (isDesktop) return null;

  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={visible}
      onRequestClose={onRequestClose}>
      <View style={styles.modalOverlay}>
        <SafeAreaView style={[styles.modalContent, { paddingTop: insets.top }]}>
          <StatusBar barStyle="dark-content" backgroundColor="white" />
          <ScrollView style={styles.scrollView}>
            <View style={styles.header}>
              <TouchableOpacity
                style={styles.buttonHeader}>
                
                <Text style={styles.textHeader}>
                  {user?.current_client.name}
                </Text>
               
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  onRequestClose();
                  closeModal();
                  (navigate as any)(AppRoutes.MAIN_TAB_SCREEN, { screen: 'Home' });
                }}>
                {Platform.OS === 'web' ? (
                  <Text style={[styles.iconX, { fontSize: 28, color: Colors.lightGray, lineHeight: 32 }]}>✕</Text>
                ) : (
                  <Feather
                    name="x"
                    size={32}
                    color={Colors.lightGray}
                    style={styles.iconX}
                  />
                )}
              </TouchableOpacity>
            </View>
            <Text selectable style={[styles.label, styles.firstLabel]}>Cód. Brasal: <Text style={styles.value}>{user?.current_client?.clientCode || '******'}</Text></Text>
            <Text selectable style={styles.label}>CPF/CNPJ: <Text style={styles.value}>{user?.current_client?.cnpj_cpf || '*****'}</Text></Text>
            {user?.storeAccess && (
              loadingLimit ? (
                <View style={styles.saldoRow}>
                  <Text style={styles.label}>Saldo: </Text>
                  <View style={styles.saldoSkeletonBar} />
                </View>
              ) : (
                limit !== null && limit !== undefined && balance !== null && balance !== undefined && (
                  <Text selectable style={styles.label}>
                    Saldo: <Text style={styles.value}>
                      {`${balance.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} / ${limit.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`}
                    </Text>
                  </Text>
                )
              )
            )}
            <View style={styles.containerDrop}>
              <DropDownMenu
                title="Empresas"
                onPress={() => {
                  logEvent(analyticsInstance, 'companies_click', {
                    group_id: user?.current_client?.group_id,
                    client_code: user?.clientCode,
                  });
                  openModal();
                }}
                image={<Image source={Images.fabric} style={{ width: 25, height: 25 }} />}
              />
              {/* <DropDownMenu
                title="Campanhas"
                onPress={() => {
                  navigate(AppRoutes.CATALOGO);
                  onRequestClose();
                  closeModal();
                }}
                image={
                  <Image
                    source={Images.campaigns}
                    style={{tintColor: 'black'}}
                  />
                }
              /> */}
              {/* PED-13 RN-23 — o menu dedicado. É o único caminho de volta
                  para quem abandonou um pagamento: o carrinho da proposta é
                  destruído nessa hora e a notificação já se perdeu. */}
              <DropDownMenu
                title="Pedidos Programados"
                onPress={() => {
                  navigate(AppRoutes.SCHEDULED_ORDER_MENU);
                  onRequestClose();
                  closeModal();
                }}
                image={
                  <Image
                    source={Images.documentIcon}
                    style={{tintColor: 'black', width: 29, height: 29}}
                  />
                }
              />
              <DropDownMenu
                title="Meus Débitos"
                onPress={() => {
                  logEvent(analyticsInstance, 'debts_click', {
                    client_code: user?.clientCode,
                  });
                  navigate(AppRoutes.DEBTS);
                  onRequestClose();
                  closeModal();
                }}
                image={
                  <Image source={Images.documentIcon} style={{tintColor: 'black', width: 29, height: 29}} />
                }
              />
              <DropDownMenu
                title="Meus Cartões"
                onPress={() => {
                  navigate(AppRoutes.MY_CARDS);
                  onRequestClose();
                  closeModal();
                }}
                image={
                  <Image source={Images.card} style={{tintColor: 'black', width: 28, height: 18}} />
                }
              />
              <DropDownMenu
                title="Dúvidas Frequentes"
                onPress={() => {
                  logEvent(analyticsInstance, 'faq_click', {
                    client_code: user?.clientCode,
                  });
                  navigate(AppRoutes.SUPPORT);
                  onRequestClose();
                  closeModal();
                }}
                image={<Image source={Images.doubt} style={{ width: 28, height: 28 }} />}
              />
              <DropDownMenu
                title="Equipamentos"
                onPress={() => {
                  logEvent(analyticsInstance, 'equipments_click', {
                    client_code: user?.clientCode,
                  });
                  navigate(AppRoutes.EQUIPAMENT);
                  onRequestClose();
                  closeModal();
                }}
                image={<Image source={Images.tool} style={{ width: 28, height: 24 }} />}
              />
              <DropDownMenu
                title="Pedidos de Troca"
                onPress={() => {
                  logEvent(analyticsInstance, 'exchanges_click', {
                    client_code: user?.clientCode,
                  });
                  navigate(AppRoutes.EXCHANGES);
                  onRequestClose();
                  closeModal();
                }}
                image={<Image source={Images.exchangeIcon} style={{ width: 31, height: 31 }} />}
              />
              <View style={{}}>
                <DropDownMenu
                  title="Configuração"
                  onPress={() => {
                    logEvent(analyticsInstance, 'settings_click', {
                      client_code: user?.clientCode,
                    });
                    navigate(AppRoutes.PROFILE);
                    onRequestClose();
                    closeModal();
                  }}
                  color={Colors.GrayPallete.lightGrayFour}
                  image={<Image source={Images.gear} style={{ width: 28, height: 28 }} />}
                />
                <DropDownMenu
                  title="Telefone de Suporte"
                  onPress={() => {
                    logEvent(analyticsInstance, 'support_phone_click', {
                      client_code: user?.clientCode,
                    });
                    Linking.openURL('https://wa.me/+556199763531')
                    onRequestClose();
                    closeModal();
                  }}
                  color={Colors.GrayPallete.lightGrayFour}
                  image={
                    <Image
                      source={Images.whatsapp}
                      style={{ marginLeft: 3, width: 30, height: 30, tintColor: Colors.GrayPallete.lightGrayFour }}
                    />
                  }
                />
                <TouchableOpacity
                  onPress={handleLogOff}
                  style={styles.buttonLogoff}>
                  <Text style={styles.logOffText}>Sair</Text>
                </TouchableOpacity>
              </View>
            </View>
          </ScrollView>
        </SafeAreaView>
      </View>
      <CompanyModal
        onPress={onRequestClose}
        onRequestClose={handleCloseModal}
        visible={companyModal}
      />
    </Modal>
  );
};

export default MenuModal;
